import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    root: {
        width: "100%",
        "& .MuiOutlinedInput-root.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.action.disabled,
        },
        '& input[type="time"]::-webkit-calendar-picker-indicator': {
            display: "none",
        },
        '& input[type="time"]::-webkit-clear-button': {
            display: "none",
        },
        '& input[type="time"]::-ms-clear': {
            display: "none",
        },
    },
    iconButton: {
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    icon: {
        fontSize: "1em",
        "& path": {
            fill: theme.palette.primary.main,
        },
    },
    iconDisabled: {
        "& path": {
            fill: theme.palette.action.disabled,
        },
    },
}));
